// ============================================================
//  NETFORGE — EDIT YOUR COMPANY DETAILS HERE
//  Change any text, links, services, or testimonials below.
// ============================================================

export const company = {
  name: "NetForge",
  tagline: "IT & Marketing Solutions",
  heroHeadline: "We forge digital growth for ambitious brands.",
  heroSub:
    "NetForge is a full-service IT and marketing studio. We build the software, deliver the hardware, run the campaigns, and engineer the systems that scale modern businesses.",
  email: "asith.dasanayake@netforgesols.com",
  phone: "+94 70 773 3647",
  location: "Sri Lanka",
  socials: {
    twitter: "https://twitter.com",
    linkedin: "https://linkedin.com",
    github: "https://github.com",
    instagram: "https://instagram.com",
  },
  stats: [
    { value: "48h", label: "Response Time" },
    { value: "Free", label: "Initial Consultation" },
    { value: "100%", label: "Code Ownership" },
    { value: "24/7", label: "Support & Monitoring" },
  ],
};

export const services = [
  {
    key: "web",
    title: "Web & App Development",
    desc: "High-performance websites, web apps and mobile apps built with modern, scalable stacks.",
    icon: "Code2",
  },
  {
    key: "systems",
    title: "Custom Systems & CRM",
    desc: "Tailored CRMs, ERPs, dashboards and internal tools that automate operations and unify your company data.",
    icon: "Database",
  },
  {
    key: "cloud",
    title: "Cloud & IT Solutions",
    desc: "Cloud migration, DevOps, infrastructure management and round-the-clock IT support.",
    icon: "Cloud",
  },
  {
    key: "hardware",
    title: "IT Hardware Solutions",
    desc: "Procurement, setup and support of servers, networking gear, workstations and on-site infrastructure.",
    icon: "Cpu",
  },
  {
    key: "marketing",
    title: "Digital Marketing",
    desc: "Data-driven paid media, social and content strategies that turn attention into revenue.",
    icon: "Megaphone",
  },
  {
    key: "seo",
    title: "SEO & Analytics",
    desc: "Technical SEO, keyword strategy and analytics that grow qualified organic traffic.",
    icon: "TrendingUp",
  },
  {
    key: "branding",
    title: "Branding & Design",
    desc: "Identity systems, UI/UX and creative that make your brand impossible to ignore.",
    icon: "Palette",
  },
  {
    key: "graphic",
    title: "Graphic Design",
    desc: "Logos, marketing collateral, social media creatives, packaging and print-ready assets that elevate your brand.",
    icon: "PenTool",
  },
  {
    key: "consulting",
    title: "Tech Consulting",
    desc: "Architecture reviews, product strategy and roadmaps from senior engineers.",
    icon: "Lightbulb",
  },
];

export const whyChooseUs = [
  {
    title: "Senior talent only",
    desc: "Every project is led by senior engineers and strategists — no juniors learning on your budget.",
  },
  {
    title: "Fixed timelines",
    desc: "Transparent milestones and clear delivery dates. You always know where things stand.",
  },
  {
    title: "End-to-end ownership",
    desc: "From strategy to code to growth, one accountable team handles the entire lifecycle.",
  },
  {
    title: "Measurable results",
    desc: "We report on the metrics that matter to your business, not vanity numbers.",
  },
];

export const testimonials = [
  {
    quote:
      "NetForge rebuilt our platform and cut load times by 70%. Their team feels like an extension of ours.",
    name: "Sarah Mitchell",
    role: "CTO, Brightwave",
    image:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHBvcnRyYWl0fGVufDB8fHx8MTc4MzI0NTk2N3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    quote:
      "Our lead volume tripled within three months of working with their marketing team. Genuinely impressive.",
    name: "David Chen",
    role: "Founder, LoopHQ",
    image:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHBvcnRyYWl0fGVufDB8fHx8MTc4MzI0NTk2N3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    quote:
      "Reliable, fast and creative. NetForge handles our entire tech stack so we can focus on our customers.",
    name: "Elena Rodriguez",
    role: "CEO, Nordic Retail",
    image:
      "https://images.pexels.com/photos/31869537/pexels-photo-31869537.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const images = {
  heroBg:
    "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMHRlY2hub2xvZ3klMjBuZXR3b3JrJTIwZGFya3xlbnwwfHx8fDE3ODM0MTY2NDd8MA&ixlib=rb-4.1.0&q=85",
  about:
    "https://images.pexels.com/photos/8102681/pexels-photo-8102681.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
